import React, { useState, useCallback } from 'react';
import { View } from 'react-native';

import { Text, TextInput } from '../../components';
import { PrimaryButton } from '../../design/components';
import useDialogSaveButton from '../../hooks/useDialogSaveButton';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const DocketCashBagDetail = ({
	modifyServiceDocket,
	cashBag: defaultValue,
	disabled = false,
	showTitle = true,
}) => {
	const styles = useThemedStyles(createStyles);
	const [cashBag, setCashBag] = useState(defaultValue);

	const onSave = useCallback(async () =>  {
		await modifyServiceDocket({ cashBag });
	}, [modifyServiceDocket, cashBag]);

	const { isSaveButtonPressed, onSaveButtonPress } = useDialogSaveButton(onSave);

	return (
		<View style={styles.container}>
			{showTitle && <Text style={styles.title} accessibilityRole="header">Cash bag</Text>}
			<TextInput
				autoFocus={true}
				value={cashBag || ''}
				onChange={setCashBag}
				selectTextOnFocus={true}
				placeholder="Enter cash bag"
			/>
			<PrimaryButton
				size="compact"
				label="Submit"
				onPress={onSaveButtonPress}
				loading={isSaveButtonPressed}
				disabled={disabled}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		paddingTop: space.sm,
		gap: space.md,
	},
	title: {
		...type.cardTitle,
		color: colors.text,
	},
});

export default DocketCashBagDetail;
